// ─────────────────────────────────────────────────────────────────
// Design tokens — source de vérité unique du thème.
//
// Les composants consomment exclusivement des RÔLES (surface, border,
// accent, ok, danger…), jamais des valeurs brutes. Toute couleur,
// tout rayon et toute taille de police de l'app vient d'ici.
// ─────────────────────────────────────────────────────────────────

// 3 rayons au lieu de 19
const radius = {
    sm: '6px',      // boutons, inputs, chips
    md: '10px',     // cartes, tableaux, panneaux
    pill: '999px',  // badges, pills
};

// 6 rôles typographiques au lieu de 28 tailles
const type = {
    pageTitle: '1.5rem',    // 21px · 800
    cardTitle: '1.05rem',   // 15px · 800
    body: '0.875rem',       // 14px · 400
    table: '0.8125rem',     // 13px · 400
    caption: '0.78rem',     // 12.5px · 400
    label: '0.6875rem',     // 11px · 700 · uppercase
};

export const lightTheme = {
    // Fonds
    ground: '#FAFCFF',
    surface: '#FFFFFF',
    surface2: '#F3F8FD',
    surface3: '#E9F2FB',

    // Traits
    border: '#DCE7F3',
    borderStrong: '#B7CDE4',

    // Texte
    text: '#10243E',
    text2: '#51698A',
    text3: '#7E93AE',

    // Accent
    accent: '#0D74CE',
    accentHover: '#0B65B5',
    accentSoft: '#E3F0FC',
    accentText: '#0B65B5',
    onAccent: '#FFFFFF',

    // Sémantique
    ok: '#217C4E',      okSoft: '#E2F5EA',
    warn: '#9A6700',    warnSoft: '#FCF0DB',
    danger: '#C6373E',  dangerSoft: '#FCE8E9',
    rssi: '#6E56CF',    rssiSoft: '#EEEBFC',

    // Ombres
    shadowSm: '0 1px 2px rgba(16, 36, 62, 0.06)',
    shadowMd: '0 8px 24px rgba(16, 36, 62, 0.12)',

    radius,
    type,
};

export const darkTheme = {
    ground: '#0B1420',
    surface: '#101B2A',
    surface2: '#0D1725',
    surface3: '#16283C',

    border: '#1E3048',
    borderStrong: '#2E486A',

    text: '#E4EEF9',
    text2: '#93A9C4',
    text3: '#64809F',

    accent: '#1D80D7',
    accentHover: '#3D95E5',
    accentSoft: '#12293F',
    accentText: '#6AABEE',
    onAccent: '#FFFFFF',

    ok: '#52C583',      okSoft: '#10281B',
    warn: '#E0B454',    warnSoft: '#2A2113',
    danger: '#EC5D64',  dangerSoft: '#331418',
    rssi: '#9B8AE6',    rssiSoft: '#201A38',

    shadowSm: '0 1px 2px rgba(0, 0, 0, 0.35)',
    shadowMd: '0 8px 24px rgba(0, 0, 0, 0.5)',

    radius,
    type,
};
